import { useNavigate } from 'react-router-dom'

import { Card } from '@/shared/components/ui/card'
import { buildLeadFilterUrl } from '@/shared/lib/leadNavigation'

export default function ConversionRateCard({ data, period, customRange }) {
  const navigate = useNavigate()
  const content = data ?? {
    total: 0,
    subtitle: 'conversions',
    highlight: '',
    salespersons: [],
  }

  const percentage =
    content.percentage ??
    (() => {
      const totalConverted =
        content.salespersons?.reduce(
          (sum, person) => sum + (Number(person.converted) || 0),
          0,
        ) || 0

      const totalLeads =
        content.salespersons?.reduce(
          (sum, person) => sum + (Number(person.total) || 0),
          0,
        ) || 0

      return totalLeads ? Math.round((totalConverted / totalLeads) * 100) : 0
    })()

  return (
    <Card className="h-[200px] overflow-hidden rounded-2xl border border-black/[0.06] bg-white shadow-[0_8px_24px_rgba(15,23,42,0.04)] sm:rounded-[20px]">
      <div className="flex h-full flex-col p-4">
        <div
          className="shrink-0 cursor-pointer transition hover:opacity-80"
          onClick={() =>
            navigate(
              buildLeadFilterUrl('/marketing/leads', {
                status: 'won',
                period,
                customRange,
              }),
            )
          }
          title="View won leads"
        >
          <h3 className="text-sm font-semibold text-slate-900">
            Conversion Rate
          </h3>

          <div className="mt-2 flex flex-wrap items-end gap-2">
            <span className="text-[clamp(1.75rem,4vw,2.25rem)] font-extrabold leading-none tracking-tight text-slate-900">
              {content.total ?? 0}
            </span>

            <span className="pb-1 text-xs text-slate-500">
              {content.subtitle || 'conversions'}
            </span>
          </div>
        </div>

        <p
          className={`mt-1 text-xs font-semibold ${
            content.highlightColor || 'text-violet-600'
          }`}
        >
          {content.highlight}
        </p>

        <div className="mt-4 h-2 overflow-hidden rounded-full bg-slate-100">
          <div
            className="h-full rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500 transition-[width] duration-300"
            style={{
              width: `${Math.min(100, Math.max(0, Number(percentage) || 0))}%`,
            }}
          />
        </div>
      </div>
    </Card>
  )
}
